<script lang="tsx">
  import Footer from "./Footer.vue";
  import FooterSkeleton from "./FooterSkeleton.vue";

  export default {
    components: { Footer, FooterSkeleton },
    props: Footer.props as (typeof Footer["props"]),
  };
</script>

<template>
  <Suspense>
    <Footer v-bind.attr="$attrs" v-bind.prop="$props as any"/>

    <template #fallback>
      <FooterSkeleton class="p-dark" width="100%" height="calc(512px + 2em)"/>
    </template>
  </Suspense>
</template>
